import { render, staticRenderFns } from "./appData.vue?vue&type=template&id=4dcafd35&scoped=true&"
import script from "./appData.vue?vue&type=script&lang=js&"
export * from "./appData.vue?vue&type=script&lang=js&"
import style0 from "./appData.vue?vue&type=style&index=0&id=4dcafd35&scoped=true&lang=scss&"
import style1 from "./appData.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcafd35",
  null
  
)

export default component.exports